<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <!-- logo -->
        <!-- <div class="logo">
          <img
            v-if="bannerArr.length > 0"
            :src="$imgUrl + bannerArr[0].thumb"
            alt=""
          />
        </div> -->
        <!-- dxm 内容区 -->
        <div class="container app-wrap">
          <template v-if="langSet == 'cn'">
            <!-- <div class="app-title">北京分析测试学术报告会暨展览会</div>
            <div class="app-entitle">
              Beijing Conference and Exhibition on Instrumental Analysis
            </div>
            <div class="app-text">中国国际展览中心（顺义馆）</div>
            <div class="app-text">2025.09.10-12</div>
            <div class="app-btn" @click="toInfor">参展报名</div>
            <div class="video">
              <img
                v-if="bannerArr.length > 0"
                :src="bannerArr[0].thumb"
                alt=""
              />
            </div> -->
            <!-- 24.8.1 落地页 dxm -->
            <img class="app-img" src="../../assets/app_img.jpg" alt="" />
            <div class="app-btnwrap">
              <div class="app-btn1" @click="toInfor">参展报名</div>
            </div>
          </template>
          <template v-else>
            <img class="dialog_img" src="../../assets/jqqd.jpg" />
            <div class="dialog_txt">Stay Tuned</div>
          </template>
        </div>
      </el-col>
    </el-row>
    <!-- 底部 -->
    <!-- <bottom></bottom> -->
  </div>
</template>

<script>
import top from "../../components/top.vue";
// import bottom from "../../components/bottom.vue";
import { getBanner } from "@/api/api";
export default {
  components: { top },
  name: "home",
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.langSet == "cn" ? this.keydata.name_cn : this.keydata.name_en,
      meta: [
        {
          name: "description",
          content: this.keydata.description,
        },
        {
          name: "keywords",
          content: this.keydata.keywords,
        },
      ],
    };
  },
  data() {
    return {
      langSet: "",
      bannerArr: [],
      keydata: {},
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    menuArr.map((item) => {
      if (item.children) {
        item.children.map((i) => {
          if (
            i.name_cn == "参展申请" ||
            i.name_en == "Exhibition application"
          ) {
            this.keydata = i;
          }
        });
      }
    });
  },
  mounted() {
    let source = this.$route.query.source;
    if (source) {
      localStorage.setItem("source", source);
    }
    this.langSet = localStorage.getItem("languageSet") || "cn";
    this.getBannerList();
  },
  methods: {
    // zhang 获取展会服务banner
    getBannerList() {
      let data = {
        class: "参展流程",
        lang_type: this.langSet,
      };
      getBanner(data)
        .then((res) => {
          if (res.code == 1) {
            this.bannerArr = res.data.lists;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //dxm 跳转到填写信息页面
    toInfor() {
      this.$router.push({
        path: "apply",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog_img {
  width: 300px;
  margin-top: 300px;
}
.dialog_txt {
  margin-top: 40px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
}
.logo {
  width: 100%;
  height: 400px;
  img {
    width: 100%;
    height: 400px;
  }
}
.app-wrap {
  position: relative;
  text-align: center;
  padding: 60px 0 93px;
  .app-title {
    font-family: SFPro, SFPro;
    font-weight: 500;
    font-size: 43px;
    color: #000000;
    line-height: 55px;
  }
  .app-entitle {
    font-family: SFPro, SFPro;
    font-size: 25px;
    color: #7a7a7a;
    line-height: 48px;
  }
  .app-text {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 22px;
    color: #000000;
    line-height: 40px;
  }
  .app-btn {
    width: 400px;
    height: 58px;
    line-height: 58px;
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #ffffff;
    margin: 30px auto 48px;
    background: linear-gradient(180deg, #4a69be 0%, #243889 100%);
    border-radius: 7px;
    cursor: pointer;
    &:hover {
      background: #243889;
    }
  }
  .app-img {
    width: 920px;
    margin: 0 auto 130px;
  }
  .app-btnwrap {
    width: 920px;
    height: 130px;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba($color: #000000, $alpha: 0.7);
    .app-btn1 {
      width: 312px;
      height: 78px;
      line-height: 78px;
      text-align: center;
      font-weight: 500;
      font-size: 22px;
      color: #ffffff;
      background: #00a3ef;
      box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16);
      border-radius: 8px;
      cursor: pointer;
    }
  }
  .video {
    width: 80%;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
}
@media only screen and (max-width: 1280px) {
  .app-wrap {
    padding: 0;
    width: 100%;
    .app-title {
      font-size: 34px;
      line-height: 45px;
    }
    .app-entitle {
      font-size: 20px;
      line-height: 40px;
    }
    .app-text {
      font-size: 18px;
      line-height: 30px;
    }
  }
}
@media only screen and (max-width: 920px) {
  .app-wrap {
    .app-img {
      width: 100%;
    }
  }
}
@media only screen and (max-width: 767px) {
  .logo {
    height: auto;
    img {
      height: auto;
    }
  }
  .app-wrap {
    .app-title {
      font-size: 22px;
      line-height: 35px;
    }
    .app-entitle {
      font-size: 12px;
      line-height: 25px;
    }
    .app-text {
      font-size: 15px;
      line-height: 30px;
    }
    .app-btn {
      width: 70%;
    }
    .app-btnwrap{
      height: 100px;
      .app-btn1{
        font-size: 20px;
        height: 55px;
        line-height: 55px;
      }
    }
  }
}
</style>